import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth-context.js";
import { AppShell } from "./routes/AppShell.js";
import { RequirePermission } from "./routes/RequirePermission.js";
import { AlertsPage } from "./features/alerts/AlertsPage.js";
import { AuditPage } from "./features/audit/AuditPage.js";
import { DoorsPage } from "./features/doors/DoorsPage.js";
import { LoginPage } from "./features/auth/LoginPage.js";
import { WatchdogPage } from "./features/watchdog/WatchdogPage.js";
import { UsersPage } from "./features/admin/UsersPage.js";
import { RegistryPage } from "./features/admin/RegistryPage.js";

export function App() {
  const { principal, restoring } = useAuth();

  // The one-time refresh on load has not settled yet. Showing the sign-in form here would flash
  // it at users who ARE signed in, on every page load.
  if (restoring) {
    return (
      <main className="signin">
        <div className="signin-card">
          <h1>Door Control</h1>
          <p className="signin-sub">Restoring your session…</p>
        </div>
      </main>
    );
  }

  if (!principal) return <LoginPage />;

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<Navigate to="/doors" replace />} />
        <Route
          path="/doors"
          element={
            <RequirePermission permission="view_doors">
              <DoorsPage />
            </RequirePermission>
          }
        />
        <Route
          path="/alerts"
          element={
            <RequirePermission permission="view_status">
              <AlertsPage />
            </RequirePermission>
          }
        />
        <Route
          path="/watchdog"
          element={
            <RequirePermission permission="view_status">
              <WatchdogPage />
            </RequirePermission>
          }
        />
        <Route
          path="/audit"
          element={
            <RequirePermission permission="view_audit">
              <AuditPage />
            </RequirePermission>
          }
        />
        {/* Administration. Gated here for a clear "you cannot open this" screen rather than a
            403 JSON blob - the API enforces the same permission independently. */}
        <Route
          path="/registry"
          element={
            <RequirePermission permission="manage_doors">
              <RegistryPage />
            </RequirePermission>
          }
        />
        <Route
          path="/users"
          element={
            <RequirePermission permission="manage_system">
              <UsersPage />
            </RequirePermission>
          }
        />
        <Route path="*" element={<Navigate to="/doors" replace />} />
      </Route>
    </Routes>
  );
}
